const expandPainelItemLabelformActions = {
  local: 'Local',
  equipment: 'Equipment',
  equipmentReference: 'Reference point',
  service: 'Service',
  questionGroup: 'Question Group',
  questionText: 'Question',
  actionBy: 'Action created by',
  sn: 'S/N',
  description: 'Description',
  text: 'Without S/N'
};

export default expandPainelItemLabelformActions;
